import * as React from 'react';
import { Route, Routes, CompatRouter, } from "react-router-dom-v5-compat";
import { BrowserRouter, } from 'react-router-dom'

import StandardsReport from '../components/progress_reports/standards_report/index'

const StandardsReportRouter = (props) => (
  <BrowserRouter>
    <CompatRouter>
      <Routes>
        <Route element={<StandardsReport {...props} />} path="/teachers/progress_reports/standards_report/*" />
      </Routes>
    </CompatRouter>
  </BrowserRouter>
)

export default StandardsReportRouter
